import { Types } from "@ioc/types";
import { IHttpService } from "@modules/infra/http/models/IHttpService";
import { IHistoryTotalQtVolLT } from "@utils/interfaces";
import { inject, injectable } from "inversify";
import { IGetDataChartsDash } from "../dtos/IGetDataChartsDash";
import { IGetHistoryTotalQtVolLTService } from "../models/IGetHistoryTotalQtVolLTService";

@injectable()
export class GetHistoryTotalQtVolLTService
  implements IGetHistoryTotalQtVolLTService {
  // @ts-ignore
  @inject(Types.IHttpService) private httpInstance: IHttpService;

  execute(data: IGetDataChartsDash): Promise<IHistoryTotalQtVolLT[]> {
    return this.httpInstance.get<IHistoryTotalQtVolLT[]>(
      `/dashboard-posh/taxReceipt?action=${data.action}&companies_id=${data.companies_id}&type_date_trunc=${data.type_date_trunc}&from=${data.from}&to=${data.to}`
    );
  }
}
